import React from "react";
import PdfToOfficeConverter from "../../components/PdfToOfficeConverter";

const PdfToPowerpoint = () => (
  <PdfToOfficeConverter
    target="PowerPoint"
    title="Convert PDF to PowerPoint"
    description="Turn your PDF pages into an editable PPTX presentation."
  />
);

export default PdfToPowerpoint;
